import {
    actions as bookmakersListActionTypes,
} from '../common/bookmakersList'
import {
    actions as bookmakersInfoActions,
} from '../common/bookmakersInfo'
import {
    getEssentialBettingState,
} from './helpers'

const dispatchBuildBets = (store, apiName, selectedBets, feed, isExternalLogout) => {
    store.dispatch(bookmakersInfoActions.buildBetRequest(true));
    store.dispatch(bookmakersInfoActions.buildBets(
        apiName,
        selectedBets,
        feed,
        isExternalLogout,
    ))
}

const buildBets = (store, ignoreAction) => {
    const meta = getEssentialBettingState(store)
    const isUserLoggedIn = meta.isUserLoggedIn
    const containsBets = meta.selectedBets.length > 0
    const notAuthorized = ignoreAction || !isUserLoggedIn

    if (notAuthorized || !containsBets) {
        return
    }

    dispatchBuildBets(
        store,
        meta.apiName,
        meta.selectedBets,
        meta.feed,
        meta.isExternalLogout,
        meta.currencySign,
    )
}

const buildBetsMiddleware = store => next => (action) => {
    switch (action.type) {
        case bookmakersInfoActions.actionTypes.ADD_SELECTED_BET:
        case bookmakersInfoActions.actionTypes.DELETE_BET:
            buildBets(store, true)
            break
        case bookmakersListActionTypes.actionTypes.SET_USER_INFO:
            buildBets(store, false)
            break
        default:
    }
    return next(action)
}

export default buildBetsMiddleware



// WEBPACK FOOTER //
// /src/js/App/buildbets.middleware.js